import React from 'react';
import PropTypes from 'prop-types';

import { Avatar, Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material';
import { AppCardSection } from '@shared';
import OrdersList from '@views/orders/components/OrdersList';

import { ta } from 'utils';

const propTypes = {
  errors: PropTypes.array,
  courier: PropTypes.object.isRequired,
  editURL: PropTypes.string,
  orders: PropTypes.array,
  ordersLoading: PropTypes.bool,
}

const defaultProps = {
  orders: [],
  ordersLoading: false,
}

// The panel beside the team's courier list, showing whichever one is selected.
// Its identity block is laid out here rather than through AppResourceItem: that
// renders an <li>, which only belongs inside a list, and it sets the avatar
// against the whole block instead of against the name.
const CourierCard = ({ courier, ...props }) => (
  <Card>
    <CardHeader
      title={ I18n.t("activerecord.models.courier.one") }
      titleTypographyProps={{ variant: 'h6' }}
      action={ props.editURL &&
        <Button variant="text" href={props.editURL} target="_blank" rel="noopener">
          { I18n.t("actions.view_details") }
        </Button>
      }
    />

    <CardContent sx={{ pt: 0 }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar alt={courier.user && courier.user.name}>{ courier.user?.name?.[0] }</Avatar>
        <Typography variant="body1" fontWeight="bold">
          { courier.user && courier.user.name }
        </Typography>
      </Stack>

      <Stack spacing={0.5} sx={{ mt: 2 }}>
        <Typography variant="body2">{ ta("courier.phone") }: { courier.phone }</Typography>
        <Typography variant="body2">{ ta("courier.national_id") }: { courier.national_id }</Typography>
        <Typography variant="body2">{ ta("courier.uid") }: { courier.uid }</Typography>
      </Stack>
    </CardContent>

    { props.orders.length > 0 &&
      <AppCardSection title="Últimas órdenes">
        <OrdersList items={props.orders} loading={ props.ordersLoading } itemProps={{ compact: true }} />
      </AppCardSection>
    }
  </Card>
)

CourierCard.propTypes = propTypes;
CourierCard.defaultProps = defaultProps;

export default CourierCard;
